<template>
  <div>
    <v-row justify="center">
      <v-col cols="12">
        <v-card v-if="checkingToken">
          <v-progress-circular :size="70" indeterminate></v-progress-circular>
        </v-card>
        <v-card v-else flat>
          <v-card-text v-if="!failed">
            <v-row align="center">
              <v-col cols="auto">
                <h3 class="mx-4 basic--text">
                  Update Google Authorization Token:
                </h3>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-4 mx-4">
              <table style="width: 100%">
                <tr>
                  <td class="font-weight-medium">Step 1</td>
                  <td>
                    Open link:
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          @click="openInstructions"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-help-circle</v-icon
                        >
                      </template>
                      <span>See instructions</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <a
                      class="font-weight-medium text-decoration-underline"
                      :href="link"
                      target="_blank"
                      >Link</a
                    >
                  </td>
                </tr>

                <tr>
                  <td class="font-weight-medium">Step 2</td>
                  <td>Paste code here:</td>
                  <td>
                    <v-text-field
                      outlined
                      dense
                      hide-details="auto"
                      style="max-width: 500px"
                      v-model="code"
                    ></v-text-field>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-medium">Step 3</td>
                  <td>Refresh token:</td>
                  <td>
                    <v-btn
                      color="accent"
                      :disabled="code == ''"
                      @click="getNewToken"
                      :loading="loading"
                      >Generate new token
                      <v-icon right>mdi-refresh</v-icon></v-btn
                    >
                    <v-alert
                      class="mt-2"
                      max-width="500px"
                      type="error"
                      v-if="tokenCreationFailed"
                      >Token creation unsuccessfull. Try again.</v-alert
                    >
                  </td>
                </tr>
              </table>
            </v-row>
          </v-card-text>
          <v-card-text v-else>
            <v-col>
              <h3 class="red--text">{{ errorMessage }}</h3>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog max-width="700px" v-model="instructionsDialog">
      <v-card>
        <v-card-text>
          <table style="width: 100%">
            <tr>
              <td class="font-weight-medium">Step 1</td>
              <td>Set permissions:</td>
              <td>
                <v-img
                  max-width="600px"
                  contain
                  src="@/assets/productsDB_access.png"
                >
                </v-img>
              </td>
            </tr>
            <tr>
              <td class="font-weight-medium">Step 2</td>
              <td>Copy code:</td>
              <td>
                <v-img max-width="600px" contain src="@/assets/code.png">
                </v-img>
              </td>
            </tr>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "GoogleAuthorization",
  components: {},
  props: {},
  data: () => ({
    checkingToken: true,
    errorMessage: "",
    failed: false,
    link: "",
    code: "",
    loading: false,
    tokenCreationFailed: false,
    instructionsDialog: false,
  }),

  methods: {
    openInstructions() {
      this.instructionsDialog = true;
    },
    async checkToken() {
      this.failed = false;
      this.tokenCreationFailed = false;
      try {
        const response = await this.$store.dispatch("checkGoogleToken");

        if (response.status == 200) {
          this.$emit("validToken");
        }
      } catch (error) {
        if (error.response.status == 401) {
          this.link = error.response.data;
          this.checkingToken = false;
        } else {
          if (error.response.data) {
            this.errorMessage = error.response.data;
          } else {
            this.failed = true;
            this.errorMessage = "Sorry, something went wrong...";
          }
        }
      }
    },
    async getNewToken() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch("postNewToken", {
          code: this.code.trim(),
        });

        if (response.status == 200) {
          this.$emit("validToken");
        }
      } catch (error) {
        console.log(error);
        this.tokenCreationFailed = true;
        this.loading = false;
      }
    },
  },
  mounted() {
    this.checkToken();
  },
};
</script>
